import Config from '@Config';
import ControlsScene from "@Scenes/Main/Controls/ControlsScene";

import * as Scenes from '@Config/scenes';
import Devices from '@Config/devices';

/**
 * Base Controls
 */
class BaseControls extends ControlsScene
{
    private controlsScene: string;

    constructor()
    {
        super(Scenes.BASE_CONTROLS);

        if (Config.DEVICE === Devices.DESKTOP)
        {
            this.controlsScene = Scenes.KEYBOARD_CONTROLS;
        }
        else
        {
            this.controlsScene = Scenes.LEFT_RIGHT_CONTROLS;
        }
    }

    /**
     * Create callback
     * This fires as part of the phaser scene lifecycle
     */
    public create(): void
    {
        this.enableInput();

        this.scene.launch(this.controlsScene);

        this.enableShutdown();
    }

    /**
     * Shuts down children scenes
     */
    public shutdown(): void
    {
        this.scene.stop(this.controlsScene);
    }
}

export default BaseControls;